import React from 'react';
import styled, { css } from 'styled-components';
import { ColorNordicGrey1, Spacing16 } from 'autogen/design-tokens/tokens';
import { breakpoint, sizes } from 'variables';

const Wrapper = styled.i<{ hasTopBorder: boolean }>`
    display: block;
    padding: ${Spacing16} 0;

    ${breakpoint.up(sizes.xl)} {
        padding-left: ${Spacing16};
        padding-right: ${Spacing16};
    }

    ${({ hasTopBorder }) =>
        hasTopBorder &&
        css`
            border-top: 1px solid ${ColorNordicGrey1};
        `}
`;

interface IMinimumSalesQuantityDescription {
    minimumSalesQuantityDescription: string;
    hasTopBorder: boolean;
}

export default function MinimumSalesQuantityDescription({
    minimumSalesQuantityDescription,
    hasTopBorder
}: IMinimumSalesQuantityDescription): JSX.Element {
    return (
        <Wrapper hasTopBorder={hasTopBorder} dangerouslySetInnerHTML={{ __html: minimumSalesQuantityDescription }} />
    );
}
